import Vue from 'vue'
import showFile from './showFile.vue'
import { Message } from 'element-ui'
import md5 from 'blueimp-md5'
import CryptoJS from 'crypto-js'
import {api} from '@/api/api'
import http from '@/http'
import store from '@/vuex/store'

let showFileConstructor = Vue.extend(showFile)
let instance

const selectTip = function(options = {}) {
  let url = options.url
  if (options.database) {
    http.post(
      api['copyFile'],
      {origin_url: encodeURIComponent(url)}
    ).then(res => {
      if (res.data.code == 0) {
        url = res.data.data.url
      } else {
        this.$message({
          type: 'warning',
          message: res.data.msg
        })
      }
    })
  }
  let suffix = urlType(url)
  let type = options.type ? 'openEditor' : 'openPreview'
  let title = options.title ? options.title : 'office'
  if (suffix == 'image' || suffix == 'video') {
    if (type == 'openEditor') {
      return Message({
        type: 'warning',
        message: `暂不支持编辑${suffix}格式`
      })
    } else {
      instance = new showFileConstructor({
        data: options
      })
      document.body.appendChild(instance.$mount().$el)
    }
  } else {
    instance = new showFileConstructor({
      data: options
    })
    document.body.appendChild(instance.$mount().$el)
    // editFile(url, type, title, suffix)
  }
}
function urlType (url) {
  // 后缀获取
  var suffix = ''
  // 获取类型结果
  var result = ''
  try {
    var flieArr = url.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  // fileName无后缀返回 false
  if (!suffix) {
    return '-1'
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'image'
    return result
  }
  var videolist = ['mp4', 'm2v', 'mkv']
  result = videolist.some(function (item) {
    return item == suffix
  })
  if (result) {
    result = 'video'
    return result
  }
  return suffix
}

function editFile(url, type, title, suffix) {
  let data = {
    doc: {
      docId: md5(url),  // 用文件地址的md5(url)作为id
      title: `${title}.${suffix}`,  // 必须保持后缀，给编辑器用于识别
      fetchUrl: url,
      callback: `/apps/res/onlineEditorCallback?origin_url=${encodeURIComponent(url)}`
    },
    user: {
      uid: 'admin',
      nickName: '管理员',
      avatar: 'https://bisheng-upload.nodoc.cn/system/defaultAvatar.png'
    }
  }
  let str = JSON.stringify(data)
  let wordArray = CryptoJS.enc.Utf8.parse(str)
  let base64 = CryptoJS.enc.Base64.stringify(wordArray)
  // openPreview
  let new_url = `http://120.26.95.88:8089/apps/editor/${type}?data=${base64}`
  window.open(new_url)
}

// export default importTip
export default {
  install (Vue, options) {
    Vue.prototype.$showFile = selectTip
  }
}



// WEBPACK FOOTER //
// ./src/components/showFile/showFile.js